import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { MatchGroupScore } from "src/features/talents/talentsTypes";
import {
  formatFieldLabel,
  formatGroupLabel,
  sortGroupScores,
} from "src/features/talents/matchingUtils";
import CustomStepper from "../shared/Stepper";

interface MatchScoresProps {
  groupScores: MatchGroupScore[];
}

const MatchScores: React.FC<MatchScoresProps> = ({ groupScores }) => {
  const sortedGroups = sortGroupScores(groupScores || []);

  return (
    <Box sx={sxProps.container}>
      <Typography variant="h6" fontWeight="bold" color="text.secondary">
        MATCH SCORES
      </Typography>

      {sortedGroups.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          No match scores available yet.
        </Typography>
      ) : (
        sortedGroups.map((group) => (
          <Box key={group.groupName} sx={sxProps.section}>
            <Box sx={sxProps.sectionHeader}>
              <Typography variant="subtitle1" color="text.secondary">
                {formatGroupLabel(group.groupName)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {Math.round(group.weightedAverage)}/100
              </Typography>
            </Box>
            <Divider />
            {group.fields.map((item) => (
              <Box key={item.fieldName} sx={sxProps.scoreItem}>
                <Typography variant="body2">
                  {formatFieldLabel(item.fieldName)}
                </Typography>
                <Typography variant="body2">
                  {Math.round(item.score)}/100
                </Typography>
              </Box>
            ))}
          </Box>
        ))
      )}
      <Typography
        variant="h6"
        fontWeight="bold"
        color="text.secondary"
        sx={{ pt: 2 }}
      >
        Positions
      </Typography>

      <CustomStepper sx={{ mt: 2 }} />
    </Box>
  );
};

export default MatchScores;

const sxProps = {
  container: {
    p: 2,
    minWidth: "300px",
    height: "100%",
    borderLeft: "1px solid #DDDDDD",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  section: {
    mt: 3,
    mb: 2,
  },
  scoreItem: {
    display: "flex",
    justifyContent: "space-between",
    my: 1,
  },
};
